import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController } from 'ionic-angular';
import { AngularFire, FirebaseListObservable } from 'angularfire2';

import moment from 'moment';
import upperFirst from 'lodash/upperFirst';

@Component({
  selector: 'page-emotion',
  templateUrl: 'emotion.html'
})
export class Emotion {

  // Loader
  loader: any = null;

  // Data
  emotionModel: any = {};
  editFlag: boolean = false;
  emotions: FirebaseListObservable<any[]>;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public af: AngularFire) {
    
    this.emotionModel = JSON.parse(JSON.stringify( navParams.get('emotion') ));
    this.editFlag = navParams.get('edit');

    this.emotions = this.af.database.list(`/emotions`);
  }

  ionViewDidLoad() {

  }

  dismissLoader() {
    if (this.loader) {
      this.loader.dismiss();
    }
  }

  dismiss() {
    this.dismissLoader();
    
    setTimeout(() => {
      this.viewCtrl.dismiss();
    }, 400);
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      dismissOnPageChange: true
    });
    this.loader.present();
  }

  validFields() {
    try {
      for (var key in this.emotionModel) {

        console.log('validFields - data', key, this.emotionModel[key], typeof this.emotionModel[key]);

        if (key !== 'timestamp' 
          && key !== 'id'
          && key !== '$key'
          && key !== '$exists'
          && key !== 'title_trm'
          && (typeof(this.emotionModel[key]) !== "boolean") 
          && (typeof(this.emotionModel[key]) !== "object")
          && !(this.emotionModel[key] instanceof Array) ) {

          if (this.emotionModel[key] === null || this.emotionModel[key].trim() == null
            || this.emotionModel[key].trim() == "" || this.emotionModel[key] === " " || this.emotionModel[key] === "  ") {
            return false;
          }

        }
      }
      return true;
    } catch (err) {
      console.log('Emotion - validFields', err);
    }
  }

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: 'Harmonised',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  showMsg(message: string) {
    this.dismissLoader();

    setTimeout(() => {
      this.showAlert(message);
    }, 400);
  }

  onClose() {
    this.dismiss();
  }

  deleteEmotions() {
    try{
      console.log('saveLevel', this.emotionModel);
      this.presentLoading();
      if (this.emotionModel.id) {
        this.emotions.remove(this.emotionModel.id);
      }
      
      setTimeout( () => {
        this.dismiss();
      }, 600);
    } catch (error) {
      console.log('deleteEmotions', error);
    }
  }

  saveEmotion() {
    try{
      console.log('saveEmotion', this.editFlag, this.emotionModel);
      this.presentLoading();

      if (!this.validFields()) {
        this.showMsg('Please, fill the form correctly.');
        return;
      }
  
      // (<any>firebase).database.ServerValue.TIMESTAMP
      let tmpModel: any = {
        title_en: upperFirst(this.emotionModel.title_en),
        title_trm: upperFirst(this.emotionModel.title_trm) || '',
        color: this.emotionModel.color.toLowerCase(),
        timestamp: moment().unix()
      };

      if (this.editFlag) {
        this.emotions.update(this.emotionModel.id, tmpModel);
      } else {
        this.emotions.push(tmpModel);
      }
      this.dismiss();
    } catch (error) {
      console.log('saveEmotion', error);
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/emotion/emotion.ts